<template>
  <div class="summary-box m-max-height" :class="{'summar-box-2':isUi2 }">
    <MbreakdownReport />
    <m-two-dimensional />
    <b-container>
      <b-row  v-if="!isUi2">
        <b-col class="summary-head title">
          <h4>Target Audience</h4>
          <b-link @click="goDemo">Edit</b-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <m-slide-item :items="demos" :canDelete = "false"/>
          <div v-if = "hasPhoneOption" class="phone-box">
            <h5 style="margin-bottom: 0">Phone Option:</h5> {{currentPhoneOption.desc}}
          </div>
          <div v-if = "hasEmailOption" class="phone-box">
            <h5 style="margin-bottom: 0">Email Option:</h5> {{emailOption}}
          </div>
        </b-col>
      </b-row>
      <b-row class="other-option">
        <b-col v-show="$store.getters['summary/showBreakDown']">
          <b-link @click="showBreakdown">View Breakdown Report</b-link>
        </b-col>
        <b-col v-show="$store.getters['summary/showTwoDimensional']">
          <b-link @click="showTwoDimensional">Two Dimensional Matrix Report</b-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import MbreakdownReport from '@/components/summary/MbreakdownReport'
  import MTwoDimensional from '@/components/summary/MTwoDimensional'
  import MSlideItem from '@/components/slide/MSlideItem.vue'

  export default {
    components: {
      MbreakdownReport,
      MSlideItem,
      MTwoDimensional
    },
    props: {
      isUi2: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      selectedDemos () {
        return this.$store.getters['order/demoItems']
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      },
      hasPhoneOption () {
        return !this.$store.getters['demo/noPhoneOption']
      },
      demos () {
        return this.$store.getters['order/demos']
      },
      currentPhoneOption () {
        return this.$store.getters['order/currentPhoneOption']
      },
      hasEmailOption () {
        return this.$store.state.order.ListType === 260 && this.$store.state.order.EmailOption !== ''
      },
      emailOption () {
        var result = "I don't need business email addresses."
        if (this.$store.state.order.EmailOption === 'onlyemail') {
          result = "I'll take only those records with a business email address."
        }
        if (this.$store.state.order.EmailOption === 'email') {
          result = "I'll take those with and without business email addresses."
        }
        return result
      }
    },
    methods: {
      goDemo () {
        this.$router.push({name: 'demo'})
      },
      showBreakdown () {
        this.$root.$emit('bv::show::modal', 'breakdownReport')
      },
      showTwoDimensional () {
        this.$root.$emit('bv::show::modal', 'twoDimensional')
      }
    }
  }
</script>

<style scoped lang="scss">
  .title {
    display: flex;
    justify-content: space-between;
  }
  .phone-box {
    margin-top: 16px;
  }
  .link{
    margin-left: 15px;
  }
  .other-option {
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MTargetAudience.vue